var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1277,
    height: 586,
    viewBox: "0 0 1277 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.514762 7.0756C89.5573 -13.866 130.985 21.2946 124.799 112.557C118.612 203.82 199.957 233.942 289 213C378.043 192.058 484.687 241.237 478.5 332.5C472.313 423.763 590.957 392.442 680 371.5C769.043 350.558 907.187 427.237 901 518.5C894.813 609.763 1187.46 585.942 1276.5 565",
    stroke: "#FDF7C2",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/path.c3820a53c3f0f4711672ef58b77556fd.svg";
export { ForwardRef as ReactComponent };